import { ProviderIcon } from "@/components/ui/ProviderIcon";
import { formatMeterProviderTabLabel } from "@shared/utils";
import * as styles from "../MeterReadingsPage.styles";
import type { ProviderTabsProps } from "./types";

const ProviderTabs = ({ items, selectedId, onSelect }: ProviderTabsProps) => {
  const tabs = items.map(({ provider, addressName }) => ({
    key: provider.id,
    label: formatMeterProviderTabLabel(provider.name, addressName),
    providerName: provider.name,
    className: provider.id === selectedId ? styles.tabElectricityActive : styles.tabButtonInactive,
    iconClassName: provider.id === selectedId ? "text-primary-foreground" : undefined,
    handleSelect: () => onSelect(provider.id),
  }));

  return (
    <div className={styles.tabRow}>
      {tabs.map((tab) => (
        <button key={tab.key} onClick={tab.handleSelect} title={tab.label} aria-label={tab.label} className={tab.className}>
          <ProviderIcon provider={tab.providerName} size="sm" className={tab.iconClassName} />
          <span className="truncate">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ProviderTabs;
